<template>
  <div class="container">
    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 10 }">
      <a-form-item label="业务流水号" has-feedback>
        <span >{{ dataSourceInfo.applyNo }}</span>
      </a-form-item>
      <a-form-item label="投保申请数据" has-feedback>
        <span class="no-wrap">{{ dataSourceInfo.applyData }}</span>
      </a-form-item>
      <a-form-item label="数字信封加密" has-feedback>
        <span class="no-wrap">{{ dataSourceInfo.digitalEnvelope }}</span>
      </a-form-item>
        <a-button type="primary" size="large" class="btnBX" @click="btnBX">
          标证通解密
        </a-button>

    </a-form>
    <a-modal
      class="rules"
      v-model="tipShow"
      title=""
      centered
      :mask-closable="false"
    >
      <img id="qrcodeImage" alt="code" v-show="qrcodeImageShow">
      <template v-slot:footer>
      </template>
    </a-modal>
  </div>
</template>

<script>
import apis from "@/api/insurePreWj.js";
EpCaObj.prototype.Encrypt=function(OrgData){try{var EncData={'body':{'qrinfo':{'ext':{'CertPath':''},'decryptobjects':[{'org':OrgData}],'qrcodetype':'Encrypt'}}};var rtnVRRes=iWebNet.PostMsg(EncData);if(rtnVRRes!=''){return rtnVRRes.body.qrinfo.decryptobjects[0]['encryed'];}else return'';}catch(ex){ThrowEx('加密出现异常，请检查锁是否插好!')}}
EpCaObj.prototype.Decrypt= function(JiaMiData){try{var DecData={'body':{'qrinfo':{'decryptobjects':[{'encryed':JiaMiData}],'qrcodetype':'Decrypt'}}};var rtnDec=iWebNet.PostMsg(DecData);if(rtnDec!='')return rtnDec.body.qrinfo.decryptobjects[0]['org'];else return''}catch(ex){ThrowEx('解密过程出现异常，可能的原因：'+ex.description)}}
export default {
  name: "InsurePreWj",
  components: {
    
  },
  data() {
    return {
      dataSourceInfo:{
        applyno:''
      },
      qrcodeImageShow:false,
      qrcodeid:'',
      timer:null,
      tipShow: false,

    };
  },
  created() {
    iWebNet.Init(104);
    var epca = new EpCaObj(true);
    let that = this
    setTimeout(function(){
      // that.Inits()
    },1000)
    // const s = document.createElement('script');
    // s.type = 'text/javascript';
    // s.src = 'https://cdn.jsdelivr.net/npm/qrcode/build/qrcode.min.js';
    // document.body.appendChild(s);
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    async Inits(){
      let that = this
      await apis.getPredata({orderNo:this.$route.query.orderNo}).then(({ data: data }) => {
        that.dataSourceInfo=data
        
      });
      // 
      that.dataSourceInfo.digitalEnvelope = await EpCaObj.prototype.Decrypt(that.dataSourceInfo.digitalEnvelope)
      if(that.dataSourceInfo.digitalEnvelope){
        apis.postDigitalEnvelope({orderNo:that.$route.query.orderNo,digitalEnvelope:that.dataSourceInfo.digitalEnvelope}).then(({ data: data }) => {
          window.location.href = data.redirectUrl
        });
      }

    },
    btnCA(){
      this.Inits()

    },
    async btnBX(){
      let that = this
      let data ={
        orderNo: this.$route.query.orderNo,
      }
      this.tipShow = true
      await apis.getQrcode(data).then(({ data: data }) => {
        this.qrcodeImageShow = true
        // that.dataSourceInfo=data
        const text = data.qrInfo.content;  // 要编码的内容
        that.qrcodeid =  data.qrInfo.qrcodeid
        const imageElement = document.getElementById('qrcodeImage');  // 获取 img 元素
        QRCode.toDataURL(text, function(error, url) {
            if (error) {
                console.error(error);
            } else {
                imageElement.src = url;  // 将二维码图像显示在 img 元素中
                that.GetqueryResult()
            }
        });
      });
    },
    GetqueryResult(){
      let that = this
      let data ={
        orderNo: this.$route.query.orderNo,
        qrcodeid:that.qrcodeid
      }
      clearTimeout(that.timer)
      apis.getQueryResult(data).then(({ data: data }) => {
        if(data.toInsure == '0'){
          //不跳转
        }else if(data.toInsure == '1'){
          //跳转
          window.location.href = data.redirectUrl
          return false
        }
        if(data.qrstatus == '03'){
          that.tipShow = false
          that.qrcodeImageShow = false
        }else {
          that.timer = setTimeout(function(){
            that.GetqueryResult()
          },10000)
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  background-color: #fff;
  min-height: 726px;
  margin-top: 30px;
  position: relative;
}

.main {
  padding: 30px 50px 95px;
}

.pickCompany {
  margin-top: 90px;
}

.operate {
  margin-top: 80px;
}

// .notice-dialog {
::v-deep .ant-modal {
  width: 960px !important;
}

::v-deep .ant-modal-content {
  width: 960px !important;
  height: 680px !important;
  padding: 45px 50px;
  box-sizing: border-box;
}

::v-deep .ant-modal-body {
  padding: 24px 0 !important;
}

::v-deep .ant-modal-header {
  border-bottom: none;
}

::v-deep .ant-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  text-align: center;
}

::v-deep .ant-modal-footer {
  border-top: none;
  display: flex;
  justify-content: center;
}

::v-deep .ant-modal-footer button {
  padding: 12px 26px;
  height: auto;
  font-size: 16px;
  line-height: 1;
  margin-left: 50px;
}

// }
.content {
  height: 392px;
  padding: 30px;
  box-sizing: border-box;
  overflow-y: scroll;
  border: 1px solid #e5e5e5;
}
.no-wrap {
  word-wrap: break-word;
}
.btnCA{
  margin-top: 100px;
  margin-left: 450px;
  margin-right: 50px;
}
.btnBX{ 
  margin-top: 100px;
}
#qrcodeImage{
  display: block;
  margin: 0 auto;
  height: 180px;
  width: 180px;
  margin-top: 60px;
}
::v-deep .ant-modal-content{
  width: 600px !important;
  height: 400px !important;
  margin: 0 auto;
  padding:0;
}
</style>
